import { SaleType } from '@wix/package-picker-sdk';
export const SEASONAL_SALE_TYPES = new Set([SaleType.SEASONAL_SALE, SaleType.SEASONAL_EXTENDED, SaleType.SPECIAL_DISCOUNT]);
export const AI_CREDITS_DISCLAIMER_KEY = 'premium-purchase-plan.package_picker.disclaimer.ai_credits_redesign';
export const REDESIGNED_SEASONAL_SALE_KEY = 'sale.footer.offer_redesign';
export const REDESIGNED_PERSONAL_SALE_KEY = 'sale.footer.personal_sale_offer_redesign';
export const REDESIGNED_TAX_INCLUSIVE_KEY = 'page_footer.plans_disclaimer_no_vat';
export const REDESIGNED_TAX_EXCLUSIVE_KEY = 'page_footer.plans_disclaimer_applicable_tax_redesign';
//# sourceMappingURL=redesignedDisclaimer.js.map